module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Toni Blake\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("USA Today bestselling author Toni Blake's love of writing began when she won an essay contest in the fifth grade. Since then, she has written over twenty contemporary romance novels. Her books have received the National Readers' Choice Award, the Booksellers' Best Award, her work has been excerpted in "), _c('I', [_vm._v("Cosmopolitan")]), _vm._v(", and she has been nominated for a RITA Award. Toni lives with her husband in Northern Kentucky.  ")], 1)]), _vm._v(" "), _vm._m(2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/lDajCY/tc-custom/9781488054303.jpg?1716663320725",
      "alt": "This image is the cover for the book Summer to Remember, The Summer Island Novels"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Summer to Remember, The Summer Island Novels\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_c('i', [_vm._v("It’s the perfect season on Summer Island: the time for beaches, ice cream, bike rides and second chances…")])]), _c('br'), _c('br'), _vm._v("Trent Fordham thought he’d left Summer Island behind for good. But when he inherits his parents’ vacation home—the one he’d assumed was sold long ago—he finds himself stepping right back into his past."), _c('br'), _c('br'), _vm._v("Allie Hobbs is having a quiet afternoon in her cottage when a sudden storm leads a stranded cyclist to her front door. She’s expecting anyone but Trent Fordham, the man who broke her heart eight years ago and left her to pick up the pieces. And even more shocking? He claims "), _c('i', [_vm._v("she")]), _vm._v(" broke "), _c('i', [_vm._v("his")]), _vm._v(" heart!"), _c('br'), _c('br'), _vm._v("Trent has responsibilities on the mainland, but the more time he spends on the island, the more he feels compelled to stay. And then there’s Allie. Does she belong in a past left buried, or will this be the summer everything changes?\n    ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Harlequin Enterprises Limited\n   ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-cb664236","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0